import React from 'react';

const FacebookIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <g fill="#D6D6D6">
        <path
          d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm2.186 4H8.984c-1.443 0-1.951.728-1.951 1.951v.9h-.9v1.5h.9v4.353h1.8V8.35h1.202l.16-1.5H8.834l.002-.75c0-.391.037-.601.599-.601h.751V4z"
          transform="translate(-500 -468) translate(260 156) translate(240 16) translate(0 234) translate(0 60) translate(0 2)"
        />
      </g>
    </g>
  </svg>
);

export default FacebookIcon;
